import { ComparatorReturns } from '@list-store';
import { isNullOrUndefined } from '../../queues/utils/is-null-or-undefined';

export function numberComparator(left: number, right: number): ComparatorReturns {
    const difference = left - right;
    if (difference < 0) {
        return -1;
    } else if (difference > 0) {
        return 1;
    } else {
        return 0;
    }
}

function nullAndUndefinedComparator(
    left: null | string | undefined,
    right: null | string | undefined,
    collator: Intl.Collator
): ComparatorReturns {
    if (isNullOrUndefined(left)) return 1;
    if (isNullOrUndefined(right)) return -1;
    return collator.compare(left, right) as ComparatorReturns;
}

const alphanumericCollator = new Intl.Collator('en', { numeric: true });
const alphabeticalCollator = new Intl.Collator('en', { sensitivity: 'base' });

export const alphanumericStringComparator = (left: string, right: string) =>
    nullAndUndefinedComparator(left, right, alphanumericCollator);
export const alphabeticalStringComparator = (left: string, right: string) =>
    nullAndUndefinedComparator(left, right, alphabeticalCollator);
